module.exports = __webpack_public_path__ + "img/bian_click_icon.0350c5e0.svg";